import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vdd-false-true-readonly',
  templateUrl: './vdd-false-true-readonly.component.html',
  styleUrls: ['./vdd-false-true-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddFalseTrueReadonlyComponent {
  @Input() value: string;
  @Input() label: string;
}
